import {
  Component,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
} from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

import { HttpClient } from "@angular/common/http";
import { AppConfig } from "../../../app.config";
import { LoggingService } from "../../../services/logging.service";
import {
  ContatoIndicacao,
  StatusIndicacaoModel,
} from "src/app/enums/EnumContatoIndicacao";
import { DadosPessoaisServidorModel } from "src/app/models/PagamentoModel";
import { ErrorHandlerService } from "src/app/services/errorHandler.service";
import { lastValueFrom } from "rxjs";

@Component({
  selector: "app-perfil",
  templateUrl: "./perfil.component.html",
  styleUrls: ["../popups-styles.scss", "./perfil.component.scss"],
})
export class PerfilComponent implements OnInit, OnDestroy {
  @Output() confirmarAlteracoes = new EventEmitter<boolean>(false);
  public email: string;
  public model: DadosPessoaisServidorModel;
  public modelOriginal: DadosPessoaisServidorModel;
  public carregando: boolean;
  public salvando: boolean;

  public validarMudancas = false;
  constructor(
    public snackBar: MatSnackBar,
    private httpClient: HttpClient,
    private loggingService: LoggingService,
    private errorHandlerService: ErrorHandlerService
  ) {}

  public setValidarMudancas(value: boolean) {
    this.validarMudancas = value;
    this.confirmarAlteracoes.emit(value);
  }

  public ngOnInit(): void {
    this.carregarModel();
  }
  public ngOnDestroy(): void {
    this.model = null;
    this.modelOriginal = null;
  }

  public carregarModel(): void {
    const carregarWebService = (): Promise<DadosPessoaisServidorModel> =>
      new Promise((onSuccess) => {
        lastValueFrom(  this.httpClient
          .get(AppConfig.apiEndpoint + "/DadosCadastroUsuario")
        )
          .then((response: any) => {
            const retorno = new DadosPessoaisServidorModel();
            retorno.trial = Number(response.valorCobranca) < 0;

            retorno.resumoCartao.bandeiraCartao = response.bandeira;
            retorno.resumoCartao.finalCartao = response.finalCartao;

            retorno.dadosPessoais.cpf = response.cpf;
            retorno.dadosPessoais.telefone = response.telefone;
            retorno.dadosPessoais.planoContratadoId =
              response.planoContratadoId;
            retorno.dadosPessoais.planoCancelado = response.planoCancelado;
            retorno.dadosPessoais.dataProximaCobranca = new Date(
              response.dataProximaCobranca
            );
            retorno.dadosPessoais.ValorDescontoIndicacao =
              response.valorDescontoIndicacao;
            retorno.dadosPessoais.ValorCobranca = response.valorCobranca;

            if (response.indicacoes) {
              retorno.dadosPessoais.indicacoes = new Array<ContatoIndicacao>();
              response.indicacoes.forEach((indicacao) => {
                const i = new ContatoIndicacao();

                i.nome = indicacao.nome;
                i.email = indicacao.email;
                i.dataEnvio = indicacao.dataEnvio
                  ? new Date(indicacao.dataEnvio)
                  : null;
                i.dataCadastro = indicacao.dataCadastro
                  ? new Date(indicacao.dataCadastro)
                  : null;
                i.status = StatusIndicacaoModel.status.find(
                  (s) => s.codigo === indicacao.status
                );

                retorno.dadosPessoais.indicacoes.push(i);
              });
            }

            onSuccess(retorno);
          })
          .catch((error) => {
            this.errorHandlerService.handleError(error);
          });
      });

    this.carregando = true;
    this.model = null;
    this.modelOriginal = null;

    carregarWebService()
      .then((result) => {
        this.model = result;
        this.modelOriginal = result;
        this.carregando = false;
      })
      .catch((error) => {
        this.snackBar.open(error, "OK!");
        this.carregando = false;
        this.errorHandlerService.handleError(error);
      });
  }

  public childFormSaving(msgCarregamento = false): void {
    if (msgCarregamento) {
      this.carregando = true;
    } else {
      this.salvando = true;
    }
  }

  public childFormSaved(msg, msgCarregamento = false): void {
    this.loggingService.logEvent("Editar Pefil", null, null);

    this.setValidarMudancas(false);
    this.snackBar.open(msg, "OK!", {
      duration: 10000,
    });

    if (msgCarregamento) {
      this.carregando = false;
    } else {
      this.salvando = false;
    }

    this.carregarModel();
  }
}
